const urlServer='http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com'
//const urlServer='http://localhost:3000'
export const getPlotyAnnio = async (param) =>{
    try{
        let url = `${urlServer}/api/plotyPais?annio=${param['annio']}&pais=${param['pais']}&sensor=${param['sensor']}&pcFiltro=${param['pcFiltro']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getPlotyEstado = async (param) =>{
    try{
        let url = `${urlServer}/api/plotyEstado?annio=${param['annio']}&pais=${param['pais']}&estado=${param['estado']}&sensor=${param['sensor']}&pcFiltro=${param['pcFiltro']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getPlotyMunicipio = async (param) =>{
    try{
        let url = `${urlServer}/api/plotyMunicipio?annio=${param['annio']}&pais=${param['pais']}&estado=${param['estado']}&municipio=${param['municipio']}&sensor=${param['sensor']}&pcFiltro=${param['pcFiltro']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getPlotyPromedio = async (param) =>{
    try{
        let url = `${urlServer}/api/plotyPromedio?annioIni=${param['annioIni']}&annioFin=${param['annioFin']}&pais=${param['pais']}&estado=${param['estado']}&municipio=${param['municipio']}&opcion=${param['opcion']}&sensor=${param['sensor']}&pcFiltro=${param['pcFiltro']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}